import React from 'react';

import { isEmpty, cloneDeep } from 'lodash';

import ACCategory from '../../atoms/ACCategory';
import POI from './POI';

export default class POICategory extends React.Component {
  renderPOICategory(category, pois) {
    if (isEmpty(pois)) return null;

    return (
      <div>
        {this.props.showCategory && <ACCategory label={category} onUpdateTextFunc={this.props.onUpdateCategoryNameFunc} />}
        {pois.map(poi => {
          return (
            <POI
              poi={cloneDeep(poi)}
              onSwapPOIsFunc={this.props.onSwapPOIsFunc}
              highlight={this.props.highlight}
              highlightDestinationFunc={this.props.highlightDestinationFunc}
              onClickPOIFunc={this.props.onClickPOIFunc}
              showCategory={this.props.showCategory}
              onDeletePOIFunc={this.props.onDeletePOIFunc}
            />
          );
        })}
      </div>
    );
  }

  render() {
    const { category = '', pois = [] } = this.props;

    return <div>{this.renderPOICategory(category, pois)}</div>;
  }
}
